export default "__VITE_ASSET__CXUYKA6X__"